import React from 'react';
import type { RichContent } from '@wix/ricos';

import { CardContent } from 'wui/CardContent';

import { GROUPS_APP_DEFINITION_ID } from '../../../../constants';
import { RicosViewer } from 'common/components/Ricos/RicosViewer';

interface IProps {
  groupId: string;
  content?: RichContent;
}

export function CustomSourceViewer(props: IProps) {
  const { groupId, content } = props;

  if (!content) {
    return <CardContent />;
  }

  return (
    <CardContent>
      <RicosViewer
        groupId={groupId}
        postId={groupId}
        containerId={GROUPS_APP_DEFINITION_ID}
        usage="CustomTab"
        contentId="custom_tab"
        content={content}
      />
    </CardContent>
  );
}

CustomSourceViewer.displayName = 'CustomSourceViewer';
